import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY } from '@sortlist-frontend/design-system/legacy';
import Image from 'next/image';

type SectionImageProps = {
  isCropped?: boolean;
};

export const SectionImage = styled(Image, {
  shouldForwardProp: (prop) => prop !== 'isCropped',
})<SectionImageProps>`
  height: auto;
  @media only screen and (min-width: ${BREAKPOINTS_LEGACY.sm}) {
    width: ${(props) => (props.isCropped ? '133%' : '100%')};
    transform: ${(props) => (props.isCropped ? 'translateY(10%) translateX(10%)' : 'none')};
    position: ${(props) => (props.isCropped ? 'absolute' : 'relative')};
  }
`;
